import { useRef, useState } from "react";

export default function BeforeAfter({ before, after, beforeLabel = "Before", afterLabel = "After" }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const move = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const p = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
    setPos(p);
  };

  return (
    <div
      ref={ref}
      className="compare-slider w-full aspect-[16/10] bg-black select-none"
      onMouseDown={() => (dragging.current = true)}
      onMouseUp={() => (dragging.current = false)}
      onMouseLeave={() => (dragging.current = false)}
      onMouseMove={(e) => dragging.current && move(e.clientX)}
      onTouchStart={() => (dragging.current = true)}
      onTouchEnd={() => (dragging.current = false)}
      onTouchMove={(e) => dragging.current && move(e.touches[0].clientX)}
      data-testid="before-after-slider"
    >
      <img src={after} alt="after" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={before} alt="before" className="absolute inset-0 w-full h-full object-cover" style={{ width: `${ref.current?.clientWidth || 1000}px`, maxWidth: "none" }} draggable={false} />
      </div>
      <div className="handle" style={{ left: `${pos}%` }} onMouseDown={() => (dragging.current = true)} onTouchStart={() => (dragging.current = true)} />
      <div className="absolute top-4 left-4 tag bg-black/60 backdrop-blur-md">{beforeLabel}</div>
      <div className="absolute top-4 right-4 tag bg-black/60 backdrop-blur-md">{afterLabel}</div>
      <input
        aria-label="Compare position"
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
        data-testid="before-after-range"
      />
    </div>
  );
}
